"use strict";
(function (global) {
    class WafDdosController {
        constructor(config) {
            this.settings = {
                charts: {
                    barChart: {
                        trafficUtilizationReportChart: {
                            id: "chartTrafficUtilizationReport",
                            dataName: "traffic_utilization_report_chart"
                        },
                        getPostRequestRateChart: {
                            id: "chartGetPostRequestRate",
                            dataName: "get_post_request_rate_chart"
                        },
                        dnsRequestRateChart: {
                            id: "chartDnsRequestRate",
                            dataName: "dns_request_rate_chart"
                        }
                    }
                },
                colors: {
                    low: "250,223,25",
                    medium: "255,144,71",
                    high: "217,89,71"
                    // Niskie: "250,223,25",
                    // 'Średnie': "255,144,71",
                    // Wysokie: "217,89,71",
                }
            };
            this.config = config;
            this.loadDataChart();
            this.createGrid();
        }

        loadDataChart() {
            const loadingDivs = document.querySelectorAll('.loading');
            const cardActions = [];

            for (const div of loadingDivs) {
                const closestCard = div.closest('.card');
                const cardHeaders = closestCard.querySelectorAll('.card-header');

                for (const headerElement of cardHeaders) {
                    const actions = headerElement.querySelectorAll('.actions');
                    cardActions.push(...actions);
                }
            }

            $(document).on('ajaxStart', () => {
                for (const div of loadingDivs) {
                    div.style.display = 'block';
                    div.classList.add('i-am-visible');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'none');
                cardActions.forEach(el => el.style.opacity = 0);
            });
            $(document).on('ajaxStop', () => {
                for (const div of loadingDivs) {
                    div.classList.add('hide-me');
                    div.addEventListener('transitionend', () => div.style.display = 'none');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'block');
                cardActions.forEach(el => el.style.opacity = 1);
            });
            const trafficUtilizationReportEl = document.getElementById('chartTrafficUtilizationReportTab');
            const trafficUtilizationReportSpan = trafficUtilizationReportEl.querySelector('span');
            const trafficUtilizationReportDiv = trafficUtilizationReportEl.querySelector('div');

            const getPostRequestRateEl = document.getElementById('chartGetPostRequestRateTab');
            const getPostRequestRateSpan = getPostRequestRateEl.querySelector('span');
            const getPostRequestRateDiv = getPostRequestRateEl.querySelector('div');

            const dnsRequestRateEl = document.getElementById('chartDnsRequestRateTab');
            const dnsRequestRateSpan = dnsRequestRateEl.querySelector('span');
            const dnsRequestRateDiv = dnsRequestRateEl.querySelector('div');

            ApiConnect.get(this.config.chart_data_url).then(data => {
                // noinspection JSUnresolvedVariable
                const trafficUtilizationReportValues = data.data.traffic_utilization_report_chart.values;
                // noinspection JSUnresolvedVariable
                const getPostRequestRateValues = data.data.get_post_request_rate_chart.values;
                // noinspection JSUnresolvedVariable
                const dnsRequestRateValues = data.data.dns_request_rate_chart.values;

                if (trafficUtilizationReportValues.length === 0) {
                    trafficUtilizationReportSpan.style.display = 'block';
                } else {
                    trafficUtilizationReportDiv.style.display = 'block';
                    this.drawTrafficUtilizationReportChart(data);
                }

                if (getPostRequestRateValues.length === 0) {
                    getPostRequestRateSpan.style.display = 'block';
                } else {
                    getPostRequestRateDiv.style.display = 'block';
                    this.drawGetPostRequestRateChart(data);
                }

                if (dnsRequestRateValues.length === 0) {
                    dnsRequestRateSpan.style.display = 'block';
                } else {
                    dnsRequestRateDiv.style.display = 'block';
                    this.drawDnsRequestRateChart(data);
                }

                this.setCardHeaders(data);
            }).catch((errorThrown) => {
                console.log('Błąd wczytywania danych: ', errorThrown);
            }).finally(() => {
                for (const div of loadingDivs) {
                    div.classList.add('hide-me');
                    div.addEventListener('transitionend', () => div.style.display = 'none');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'block');
                cardActions.forEach(el => el.style.opacity = 1);
            });
        }

        setCardHeaders(data) {
            const barChartSettings = this.settings.charts.barChart;
            document.querySelectorAll('.charts .char-tab').forEach(node => node.classList.remove('active'));
            const barChartKeys = Object.keys(barChartSettings);
            const firstBarChartSettings = barChartSettings[barChartKeys[0]];
            const firstBarChartId = firstBarChartSettings.id;
            const firstBarChartTabId = firstBarChartSettings.id + 'Tab';
            const firstBarChartDataName = firstBarChartSettings.dataName;
            const firstBarChart = document.getElementById(firstBarChartId);

            const barChartTab = firstBarChart.closest('.char-tab');
            barChartTab.classList.add('active');
            const barChartCard = firstBarChart.closest('.card');
            const barChartTitleEl = barChartCard.querySelector('.chart-title');
            barChartTitleEl.textContent = data.data[firstBarChartDataName].name;

            const firstBarChartTab = document.getElementById(firstBarChartTabId);
            firstBarChartTab.classList.add('active');

            const barChartMenuEl = document.querySelector('.bar-chart-menu');

            for (const key of barChartKeys) {
                const chart = barChartSettings[key];
                barChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
            }

            this.bindChangeTabBarChart();
        }

        bindChangeTabBarChart() {
            const chartTabToggles = document.querySelectorAll('.char-tab-toggle');

            for (const toggle of chartTabToggles) {
                toggle.addEventListener('click', e => {
                    e.preventDefault();
                    const target = document.getElementById(toggle.getAttribute('data-target-id'));

                    if (target) {
                        const otherTabs = Array.prototype.filter.call(target.parentNode.children, child => {
                            return child !== target;
                        });

                        for (const tab of otherTabs) {
                            tab.classList.remove('active');
                        }

                        target.classList.add('active');
                    }

                    const cardHeader = toggle.closest('.card-header');
                    const chartTitleEl = cardHeader.querySelector('h2');
                    chartTitleEl.textContent = toggle.textContent;
                });
            }
        }

        drawTrafficUtilizationReportChart(data) {
            this.trafficUtilizationReportChart = new NS.Charts.BarChart({
                "container-id": this.settings["charts"]["barChart"]["trafficUtilizationReportChart"]["id"],
                data: data["data"][this.settings["charts"]["barChart"]["trafficUtilizationReportChart"]["dataName"]].values,
                multidata: true,
                name_mapping: {
                    legal: "Ruch legalny " + data['data']['traffic_utilization_report_chart_units'],
                    attack: "Ruch związany z atakiem " + data['data']['traffic_utilization_report_chart_units'],
                },
                colors: {
                    legal: "250,223,25",
                    medium: "255,144,71",
                    attack: "217,89,71",
                },
                show_legend: this.config['show_legend']
            });
        }

        drawGetPostRequestRateChart(data) {
            this.getPostRequestRateChart = new NS.Charts.BarChart({
                "container-id": this.settings["charts"]["barChart"]["getPostRequestRateChart"]["id"],
                data: data["data"][this.settings["charts"]["barChart"]["getPostRequestRateChart"]["dataName"]].values,
                multidata: true,
                name_mapping: {
                    requests: "Średnia liczba żądań HTTP (RPS)",
                },
                colors: {
                    requests: "255,144,71",
                },
                show_legend: this.config['show_legend']
            });
        }

        drawDnsRequestRateChart(data) {
            this.dnsRequestRateChart = new NS.Charts.BarChart({
                "container-id": this.settings["charts"]["barChart"]["dnsRequestRateChart"]["id"],
                data: data["data"][this.settings["charts"]["barChart"]["dnsRequestRateChart"]["dataName"]].values,
                multidata: true,
                name_mapping: {
                    legal_ipv4: "Ruch legalny IPv4 (QPS)",
                    legal_ipv6: "Ruch legalny IPv6 (QPS)",
                    attack_ipv4: "Ruch związany z atakiem IPv4 (QPS)",
                    attack_ipv6: "Ruch związany z atakiem IPv6 (QPS)"
                },
                colors: {
                    legal_ipv4: "255,162,100",
                    legal_ipv6: "255,137,57",
                    attack_ipv4: "255,103,0",
                    attack_ipv6: "217,89,71"
                },
                show_legend: this.config['show_legend']
            });
        }

        bindExport(dataSource) {
            for (const id of ['pdf-export', 'csv-export']) {
                const button = document.getElementById(id);

                button.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    const filterStartIndex = dataSource.baseUrl.indexOf('/ddos?');
                    let filterString = dataSource.baseUrl.substring(filterStartIndex).replace('/ddos', '');
                    const basePath = button.getAttribute('href');
                    dataSource['filterValues'].forEach(filter => {
                        if (filter['value']) {
                            filterString += '&filters[' + filter['dataIndex'] + ']=' + filter['value'];
                        }
                    });

                    if (dataSource['sortValues']) {
                        if (dataSource['sortValues']['order']) {
                            filterString += '&sort[order]=' + dataSource['sortValues']['order'];
                        }
                        if (dataSource['sortValues']['order']) {
                            filterString += '&sort[key]=' + dataSource['sortValues']['dataIndex'];
                        }
                    }

                    window.open(basePath + filterString);
                });
            }
        }

        createGrid() {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                columnDefinitions: [
                    {
                        label: "Rozpoczęcie ataku",
                        dataIndex: "start_time",
                        dataType: "text",
                        isEditable: false,
                        isFilterable: true
                    }, {
                        label: "Zakończenie ataku",
                        dataIndex: "end_time",
                        dataType: "text",
                        isEditable: false,
                        isFilterable: true
                    }, {
                        label: "Nazwa ataku + ryzyko",
                        dataIndex: "name",
                        dataType: "text",
                        isEditable: false,
                        isSortable: true,
                        isFilterable: true,
                        width: '*'
                    }, {
                        label: "Status ataku",
                        dataIndex: "status",
                        dataType: "text",
                        isEditable: false,
                        isFilterable: true
                    }, {
                        label: "Wolumen (liczba pakietów)",
                        dataIndex: "packet_count",
                        dataType: "text",
                        isEditable: false,
                        isFilterable: true
                    }, {
                        label: "Wolumen (pps)",
                        dataIndex: "pps",
                        dataType: "text",
                        isEditable: false,
                        isSortable: true,
                        isFilterable: true
                    }, {
                        label: "Wolumen (liczba bitów)",
                        dataIndex: "packet_bandwidth_in_bits",
                        dataType: "text",
                        isEditable: false,
                        isFilterable: true
                    }, {
                        label: "Wolumen (bps)",
                        dataIndex: "bps",
                        dataType: "text",
                        isEditable: false,
                        isSortable: true,
                        isFilterable: true
                    }, {
                        label: "Akcje",
                        dataIndex: "actions",
                        dataType: "link",
                        isEditable: false,
                        isFilterable: false,
                        isSortable: false,
                        width: 120
                    }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                url: this.config.table_data_url,
                baseParameters: {},
                updateUrl: "/js/app/update.json"
            });

            this.bindExport(dataSource);

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                id: "gridContainerId"
            });

            new NS.Grid.Control({
                id: "gridContainerWrapperId",
                containerId: 'grid-container',
                dataSource: dataSource,
                reloadTime: null, //not implemented yet
                autoLoad: true,
                columnDefinitionSource: columnDefinitionSource,
                settingsManager: settingsManager,
                allowMultiselect: false,
                showAllRows: this.config.show_all_rows || false,
                pageSize: (this.config.show_all_rows) ? 99999999 : 20,
                listeners: {
                    onDataChanged: () => {},
                    onDataSaved: () => {},
                    onDataInvalid: () => {},
                    onDataError: () => {},
                    onSelectionChange: () => {}
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.WafDdosController = WafDdosController || {};

})(window);
